const STORAGE_KEY = "MARION_PARTS_MODE";

function readTruthy(value: string | undefined): boolean | null {
  if (value === undefined) return null;
  const normalized = value.trim().toLowerCase();
  if (normalized === "1" || normalized === "true" || normalized === "yes") return true;
  if (normalized === "0" || normalized === "false" || normalized === "no") return false;
  return null;
}

function readScenarioAllowlist(): Set<string> | null {
  const raw = import.meta.env.VITE_MARION_PARTS_MODE_SCENARIOS as string | undefined;
  if (raw === undefined || raw.trim().length === 0) return null;
  return new Set(
    raw
      .split(",")
      .map((entry) => entry.trim())
      .filter((entry) => entry.length > 0),
  );
}

export function isMarionPartsModeEnabled(scenarioKey?: string | null): boolean {
  if (typeof window !== "undefined") {
    try {
      const stored = window.localStorage.getItem(STORAGE_KEY);
      const parsedStored = readTruthy(stored ?? undefined);
      if (parsedStored !== null) return parsedStored;
    } catch {
      // localStorage 不可環境では env / allowlist のみ参照する。
    }
  }

  const envEnabled = readTruthy(import.meta.env.VITE_MARION_PARTS_MODE as string | undefined);
  if (envEnabled === false) return false;

  const allowlist = readScenarioAllowlist();
  if (allowlist !== null) {
    if (scenarioKey === undefined || scenarioKey === null || scenarioKey.trim().length === 0) {
      return false;
    }
    return allowlist.has(scenarioKey.trim());
  }

  return envEnabled === true;
}
